import React from 'react'
import Lottie from 'react-lottie'
import * as animationData from '../../../assets/3iHSWY8cGa.json'
import { Button, Row } from 'reactstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import Loading from '../../Loading'
// import Header from '../../Header'
import TicketSvg from '../../../assets/icons/TicketSvg'
// import HistoryIconSvg from '../../../assets/icons/HistoryIconSvg'

const TheatreSuccess = () => {
  const navigate = useNavigate()
  const { state } = useLocation()

  console.log('state: ', state)

  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  const biletler = state.bilet_no?.split(',')

  return (
    <>
      {!state ? (
        <Loading />
      ) : (
        <>
          {/* <Header backButton={false} /> */}
          <div
            style={{
              with: '100%',
            }}
          >
            <Lottie options={defaultOptions} height={200} width={200} />

            <Row
              style={{
                display: 'flex',
                textAlign: 'center',
                color: '#285843',
              }}
            >
              <p
                style={{
                  fontWeight: 500,
                  fontSize: 25,
                }}
              >
                Biletlerin Başarıyla Alındı
              </p>
            </Row>
            <Row
              style={{
                display: 'flex',
                justifyItems: 'center',
                textAlign: 'center',
                marginLeft: '0.5rem',
                marginRight: '0.5rem',
                color: '#6E6E6E',
              }}
            >
              <p>
                <b>
                  {biletler?.map((item, i) => (biletler[i] !== biletler[biletler?.length - 1] ? `#${item}, ` : `#${item} `))} numaralı {biletler?.length === 1 ? 'biletin' : 'biletlerin'}
                </b>{' '}
                oluşturuldu. {state?.renderSuccessTitle} saatinde {state?.renderSuccessSalon} olmayı unutma. 😊
              </p>
            </Row>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginBottom: '3rem',
            }}
          >
            <div className='divider' style={{ backgroundColor: '#d4d4d4' }} />
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: '#285843',
              marginTop: '1rem',
            }}
          >
            <Button
              block
              style={{
                marginRight: '1rem',
                marginLeft: '1rem',
                backgroundColor: '#fff',
                color: '#205c42',
                borderColor: '#205c42',
                borderRadius: '50px',
                paddingTop: '0.5rem',
                paddingBottom: '0.5rem',
              }}
              onClick={() => navigate('/theatre-ticket', { state: { ...state } })}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '15px',
                }}
              >
                <TicketSvg width={'1.3rem'} height={'1.3rem'} focus={true} />
                <div style={{ paddingBottom: 4 }}>Yeni Bilet Al</div>
              </div>
            </Button>
          </div>
          {/* <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: '#285843',
              marginTop: '1rem',
            }}
          >
            <Button
              block
              style={{
                marginRight: '1rem',
                marginLeft: '1rem',
                backgroundColor: '#205c42',
                color: '#fff',
                borderColor: '#205c42',
                borderRadius: '50px',
                paddingTop: '0.5rem',
                paddingBottom: '0.5rem',
              }}
              onClick={() => navigate('/history-page')}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '15px',
                }}
              >
                <HistoryIconSvg
                  width={'1.3rem'}
                  height={'1.3rem'}
                  focus={true}
                />
                <div style={{ paddingBottom: 4 }}>
                  Geçmiş Biletlerimi Görüntüle
                </div>
              </div>
            </Button>
          </div> */}
        </>
      )}
    </>
  )
}

export default TheatreSuccess
